import Promise from 'promise-polyfill';

export function find(collection, fn) {
    for (let i = 0; i < collection.length; i++) {
        if (fn(collection[i])) {
            return collection[i];
        }
    }
}

export function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);

    if (!results) {
        return null;
    }

    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function get(url) {
    const request = new XMLHttpRequest();
    request.open('GET', url, true);

    return new Promise((resolve, reject) => {
        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                resolve(JSON.parse(request.responseText));
            } else {
                reject(request);
            }
        };

        request.onerror = reject;

        request.send();
    });
}



// WEBPACK FOOTER //
// ./src/js/app/components/map/utils.js